<template>
  <div class="allWrapper" ref="mainPageRef">
    <div class="main-page" v-if="showDataPage" ref="mainDataRef">
      <!-- 标题 QuestionHeader.vue -->
      <question-header
        @needInitialScroll="needScrollAgain"
        :mtitle="mtitle"
      ></question-header>
      <!-- 切换题目按钮 -->
      <el-button
        v-if="ifnext"
        :onquestionsTop="onquestionsTop"
        size="medium"
        class="nextquestions"
        @click="Nextquestion"
        type="primary"
        >查看上一题</el-button
      >
      <el-button
        v-if="ifon"
        :onquestionsBot="onquestionsBot"
        size="medium"
        class="onquestions"
        @click="onquestion"
        type="primary"
        >回到下一题</el-button
      >
      <!-- 此处的id有存在的必要 -->
      <div class="questionWrapper">
        <single-question
          :key="Math.random()"
          :ssubject="currentSubject"
          :snum="currentIndex"
        />
      </div>
      <div class="opinionWrapper" ref="opinionWrapperRef">
        <!-- 意见  QuestionOpinion.vue -->
        <question-opinion
          ref="opinionRef"
          v-if="showOpinion.show"
          @ovalchange="getOpinionVal"
          @ofocus="putFocus"
          @oblur="opinionBlur"
          :otitle="showOpinion.value"
          :num="opinionNum"
        ></question-opinion>
      </div>
      <div class="explainWrapper">
        <!-- 解释与说明 QuestionExplain.vue -->
        <question-explain
          v-if="this.explain"
          :explain="oexplain"
        ></question-explain>
      </div>
      <div class="btnWrapper">
        <!-- 重置提交按钮   SubmitResult.vue -->
        <submit-result
          v-if="ifsubmit"
          @submitInfo="submitResultInfo"
        ></submit-result>
      </div>
    </div>
    <transition name="qloading">
      <div class="main-page-error" v-if="showErrPage" @click="reloadData">
        <div class="warningWrapper">
          <i class="loadingW"></i>
          <p class="loadFont">数据错误</p>
          <p class="loadFont">请单击空白处重新加载！！</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import QuestionHeader from "@/components/QuestionHeader/QuestionHeader";
import SingleQuestion from "@/components/SingleQuestion/SingleQuestion";
import QuestionOpinion from "@/components/QuestionOpinion/QuestionOpinion";
import QuestionExplain from "@/components/QuestionExplain/QuestionExplain";
import SubmitResult from "@/components/SubmitResult/SubmitResult";
// import singleTitle from '@/components/singleTitle/singleTitle'
import { mapGetters, mapMutations } from "vuex";
import { isDone, dealUrl, dealMainTable, ifAllRight } from "@/libs/tools";
import address from "@/libs/address";
import { isAndroid } from "@/libs/utils";
import { Button } from "element-ui";
//  1 上线关闭 测试打开
// import mockData from '@/assets/api.json'
export default {
  name: "MainPage",
  props: {},
  data() {
    return {
      ifnext: false, //上一题
      ifon: false, //下一题
      onquestionsTop: 0, //下一题的当前点击次数
      onquestionsBot: 0, //上一题的当前点击次数
      ifsubmit: false, //提交按钮默认不展示  // 1
      currentIndex: 0, // 当前题目下标
      probeType: 3,
      listenScroll: true,
      opinionFVal: "", // 建议
      mtitle: "", // 標題
      msubjects: [
        // {
        //   soptionsArr: ['选项一', '选项二', '选项三', '选项四', '选项五'],
        //   rightResult: 'A',
        //   subject: '第一题',
        // }
      ], // 測試題的數組
      opinions: {}, // 是否顯示意見輸入框
      explain: "", // 說明信息
      showDataPage: true, // 显示数据页
      showErrPage: false, // 显示错误页
      mainScroll: "",
      windowHeight: window.innerHeight,
      tmpDistance: 0,
      urlData: {},
      pushDate: "", // 问卷的推送时间
      hideKeyborderTimeout: "",
      showKeyborderTimeout: "",
    };
  },
  // 计算属性
  computed: {
    ...mapGetters({
      allSubjectList: "getAllsubjectList",
      allScores: "getAllScore",
      resultList: "getResultList",
    }),
    oexplain() {
      return "说明：" + this.explain;
    },
    showOpinion() {
      return {
        show: this.opinions.show === "true" ? true : false,
        value:
          this.opinions.value +
          '<span style="color: rgba(255, 37, 64, 1);">(必填)</span>',
      };
    },
    opinionNum() {
      return 2; // 2
      // return this.msubjects.length + 1
    },
    currentSubject: function () {
      // 计算属性，用于取出当前的题目
      return this.msubjects[this.currentIndex];
    },
  },
  // 侦听器
  watch: {
    windowHeight(newVal, oldVal) {
      // alert('new=='+newVal+',old=='+oldVal+(typeof oldVal));
      if (isAndroid()) {
        let that = this;
        if (newVal > oldVal) {
          // 隐藏键盘
          if (!!this.hideKeyborderTimeout)
            clearTimeout(this.hideKeyborderTimeout);
          this.hideKeyborderTimeout = setTimeout(() => {
            if (that.$refs.opinionRef) {
              that.$refs.opinionRef.blur();
            }
            that.$refs.mainDataRef.style[
              "transform"
            ] = `translate(0, ${that.tmpDistance}px)`;
            that.$refs.mainDataRef.style[
              "webkitTransform"
            ] = `translate(0, ${that.tmpDistance}px)`;
            that._initScroll();
          }, 300);
        } else {
          // 展开键盘
          if (!!this.showKeyborderTimeout)
            clearTimeout(this.showKeyborderTimeout);
          this.showKeyborderTimeout = setTimeout(() => {
            let opinionDom = that.$refs.opinionWrapperRef;
            let {
              top: el_top,
              height: el_height,
            } = opinionDom.getBoundingClientRect();
            let inner_h = window.innerHeight;
            let yscroll_h = that.mainScroll.y;
            that.tmpDistance = yscroll_h;
            // alert(el_top+','+el_height+','+inner_h+','+yscroll_h);
            if (el_top + el_height > inner_h) {
              let distancea = -(el_top + el_height - inner_h) - 20 + yscroll_h;
              // alert('==' + distancea);
              that.$refs.mainDataRef.style[
                "transform"
              ] = `translate(0, ${distancea}px)`;
              that.$refs.mainDataRef.style[
                "webkitTransform"
              ] = `translate(0, ${distancea}px)`;
            }
          }, 300);
        }
      }
    },
  },
  // 事件处理
  methods: {
    ...mapMutations({
      add: "addSubScore",
      updateScore: "updateSubject", //
    }),
    // 点击上一题
    Nextquestion() {
      console.log(this.onquestionsTop, this.onquestionsBot)
      // 如果是第一题
      if (this.currentIndex == 0) {
        //  设置上一题点击无效
        this.$tips.info({
          type: "info",
          duration: 0.6,
          content: "请选择下一题 !",
          canClick: false,
        });
        this.ifsubmit = false;
        // 如果不是第一题
      } else {
        //  点击之后回到上一题
        this.currentIndex--;
        this.ifsubmit = false;
        this.onquestionsTop++; //上一题每次的点击次数
        this.onquestionsBot++; //下一题每次的点击次数
      }
    },
    onquestion() {
      // 只有当你点击了回到上一题 回到下一题才能点
      // 点击了上一题几次 下一题就能返回几次
      console.log(this.onquestionsTop, this.onquestionsBot)
      if (this.onquestionsTop != 0) {
        if (this.onquestionsTop == this.onquestionsBot) {
          this.currentIndex++;
          this.onquestionsBot--;
          this.onquestionsTop--;
        }
      } else {
        // console.log('后续点击无效');
        this.$tips.info({
          type: "info",
          duration: 0.6,
          content: "请回答题目 !",
          canClick: false,
        });
      }
    },
    scroll() {
      if (this.$refs.opinionRef) {
        this.$refs.opinionRef.blur();
      }
    },
    getOpinionVal(newval) {
      // 输入的建议
      console.log(newval);
      this.opinionFVal = newval;
    },
    putFocus() {
      console.log("focus a");
    },
    opinionBlur() {
      console.log("blur a");
    },
    aloading(type, msg, duration = 0.6, canClick = false) {
      // loading 框canClick 为true
      this.$tips.info({
        type: type,
        content: msg,
        duration: duration,
        canClick: canClick,
      });
    },
    exitCurrentPage() {
      if (!isAndroid()) {
        try {
          webkit.messageHandlers.back.postMessage({});
        } catch (error) {
          console.log("exit to ios", error);
        }
      } else {
        try {
          // android programme
          window.androidApi.backCalls();
        } catch (error) {
          console.log("exit to android", error);
        }
      }
    },
    // 提交答题数据
    submitResultInfo() {
      console.log("提交的数据", this.allSubjectList)
      if (!isDone(this.allSubjectList)) {
        this.$tips.info({
          type: "info",
          content: "请完成所有的题目 !",
          duration: 0.6,
          canClick: false,
        });
        return;
      }
      if (!Object.values(this.resultList).every(Boolean)) {
        // 判斷是否全部答對
        this.$tips.info({
          type: "info",
          content: "请选择正确答案！",
          duration: 0.6,
          canClick: false,
        });
        return;
      }
      if (!!this.showOpinion && this.showOpinion.show && !this.opinionFVal) {
        this.$tips.info({
          type: "info",
          content: "请输入意见或建议 !",
          duration: 0.6,
          canClick: false,
        });
        return;
      }

      // 提交数据必须包含分数
      // 成功 this.aloading('success', '', '', true);

      const empCode = this.urlData.empCode;
      const empName = decodeURI(this.urlData.empName);
      const org_name = decodeURI(this.urlData.org_name);
      const exam_id = this.urlData.exam_id;
      const achievement = this.allScores; // 成绩
      const push_date = this.pushDate; // 推送时间
      const os_type = this.urlData.os_type; // 手机设备
      const device_token = this.urlData.device_token; // 手机设备号
      const phone_model = decodeURI(this.urlData.phone_model); // 手机机型
      const os_version = this.urlData.os_version; // 手机版本
      const feedback = this.opinionFVal; // 建议
      const userId = this.urlData.empCode;
      const sessionId = this.urlData.sessionId;
      const casCookie = this.urlData.casCookie;
      const isIfAllRight = ifAllRight(this.allSubjectList);

      // Loading
      this.aloading("loading", "数据提交中...", "", true);
      this.$post(
        address.applyData +
          "?userId=" +
          userId +
          "&sessionId=" +
          sessionId +
          "&casCookie=" +
          casCookie,
        {
          empCode: empCode,
          empName: empName,
          org_name: org_name,
          exam_id: exam_id,
          achievement: achievement,
          push_date: push_date,
          os_type: os_type,
          device_token: device_token,
          phone_model: phone_model,
          os_version: os_version,
          feedback: feedback,
          data: "",
        }
      )
        .then((res) => {
          this.$tips.del(); // 关闭加载页
          // alert(JSON.stringify(res))
          if (!res.errorCode && res.errorCode == 0) {
            if (isIfAllRight) {
              this.aloading("success", "", "", true);
            } else {
              let shutPageTimeout;
              this.aloading("info", "数据提交成功!", 0.6, true);
              if (shutPageTimeout) clearTimeout(shutPageTimeout);
              shutPageTimeout = setTimeout(() => {
                this.exitCurrentPage();
              }, 1500);
            }
          } else if (res.errorCode == 9999) {
            this.aloading("info", "会话过期，请重新登录!", 1, false);
          } else {
            // 模拟错误数据
            this.aloading("info", "数据错误,请重新提交!", 0.6, false);
          }
        })
        .catch((err) => {
          this.$tips.del(); // 关闭加载页
          this.aloading("info", "网络错误,请检查网络!", 0.6, false);
        });
    },
    reloadData() {
      this.showDataPage = false;
      this.showErrPage = false;
      this.loadData(this.urlData);
    },
    _initScroll() {
      if (!this.$refs.mainPageRef) {
        return;
      }

      if (!this.mainScroll) {
        // better-scroll初始化
        this.mainScroll = new BScroll(this.$refs.mainPageRef, {
          probeType: this.probeType,
          click: true,
          scrollX: false,
        });
        this.mainScroll.on("beforeScrollStart", () => {
          this.scroll();
        });
      } else {
        this.mainScroll.refresh();
      }
    },
    needScrollAgain() {
      this._initScroll();
    },
    // 获取页面题目数据
    loadData(urlObj) {
      console.log(urlObj);
      this.aloading("loading", "数据加载中...", "", true);
      this.$get(address.mainUrl, {
        userId: urlObj.empCode,
        sessionId: urlObj.sessionId,
        casCookie: urlObj.casCookie,
        examId: urlObj.exam_id,
      })
        .then((res) => {
          this.$tips.del(); // 关闭加载页
          if (!res.errorCode && res.errorCode == 0) {
            // 页面的处理
            this.showDataPage = true;
            this.showErrPage = false;
            let result = res.data;
            this.mtitle = result.qsubject;
            this.pushDate = result.pushDate ? result.pushDate : "";
            this.msubjects = dealMainTable(result.allSubjectTableItem);
            this.opinions = {
              show: result.show,
              value: result.value,
            };
            this.explain = result.explains;
            this.add(this.msubjects);
            this.$nextTick(() => {
              this._initScroll();
            });
          } else {
            this.showDataPage = false;
            this.showErrPage = true;
            console.log("接口的返回的数据错误!!");
          }
        })
        .catch((err) => {
          this.$tips.del(); // 关闭加载页
          this.showDataPage = false;
          this.showErrPage = true;
          console.log("接口報錯了呀");
        });
    },
  },
  // 钩子函数
  mounted() {
    // console.log('==', this.mtitle);
    // console.log('==', this.msubjects);
    // console.log('==', this.opinions);
    // console.log('==', this.explain);
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
  // 钩子函数
  beforeDestroy() {
    window.removeEventListener("resize", () => {});
  },
  // 钩子函数
  created() {
    console.log(location.search);
    this.urlData = dealUrl(location.search);
    this.loadData(this.urlData);
  },
  // 组件
  components: {
    QuestionHeader,
    SingleQuestion,
    QuestionExplain,
    SubmitResult,
    QuestionOpinion,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import "~@/common/scss/const.scss";
@import "~@/common/scss/mixin.scss";

.allWrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  // 打开后出现多个题目产生滚动条
  // overflow-y:scroll;
  overflow-y: auto;
  .main-page {
    // 上一题
    .nextquestions {
      margin-right: 50px;
      margin-bottom: 10px;
    }
    // 下一题
    .onquestions {
      margin-left: 50px;
      margin-bottom: 10px;
    }
    .questionWrapper {
      width: 100%;
      padding: 0 pxToRem(16) 0 pxToRem(16);
    }
    .opinionWrapper {
      width: 100%;
      padding: 0 pxToRem(16) pxToRem(8) pxToRem(16);
    }
    .explainWrapper {
      width: 100%;
      padding: 0 pxToRem(16) pxToRem(8) pxToRem(16);
    }
    .btnWrapper {
      width: 100%;
      padding: 0 pxToRem(16) pxToRem(32) pxToRem(16);
    }
  }
  .main-page-error {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background: transparent;
    &.qloading-enter-active,
    &.qloading-leave-active {
      transition: opacity 0.4s linear;
    }
    &.qloading-enter,
    &.qloading-leave-to {
      opacity: 0;
    }
    .warningWrapper {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      background: transparent;
      border-radius: 4px;
      @include display-flex;
      @include flex-direction(column);
      @include justify-content(center);
      @include align-items(center);
      padding: 10px 20px;
      max-width: 90%;
      .loadingW {
        display: block;
        width: 20px;
        height: 20px;
        background: url("./images/reload.svg") no-repeat center center;
        border-radius: 50%;
        background-size: 100% 100%;
      }
      .loadFont {
        display: inline-block;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        margin-top: 8px;
        font-family: PingFangSC-Regular;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -ms-text-overflow: ellipsis;
        letter-spacing: 1px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MainPage.vue